import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const IconFont = styled.span `
  ${({ theme }) => theme.fonts.PoppinsTextMedium}
  font-size: 28px;
  color: #ffffff;
`;
function ToastErrorIcon() {
    return _jsx(IconFont, { children: "!" });
}
export default ToastErrorIcon;
//# sourceMappingURL=ToastErrorIcon.js.map